<div class="arriving-soon-shipments-page">
  <div class="shipment-arrivals-container">
    <div class="header">
      <div>
        <p class="text-muted">Shipments arriving at your locations over the next 7 days</p>
      </div>

      <button type="button" class="w-40 btn btn-primary" (click)="downloadShipment()" [disabled]="">
        Download &nbsp; <i class="fas fa-download pr-2" aria-hidden="true"></i>
      </button>
    </div>

    <div class="viewing-bar">
      <span class="text-muted">Viewing: </span> <strong>{{ customerName }}</strong>
    </div>
  </div>
  <div class="result-container">
    <div class="shipment-count-info">
      @for (item of shipmentCounts; track item) {
      <div class="shipment-count">
        <div class="label">{{ item.label }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
      }
    </div>
  </div>

  <div class="search-box" [formGroup]="shipmentArrivalForm">
    <label>Truck count by order number</label>
    <div class="col-lg-3 pl-0 pr-0 float-left p-res-0">
      <input type="text" class="form-control w-100 mb-0" placeholder="Enter Order #" formControlName="orderNumber" />
    </div>
    <button class="btn btn-primary" (click)="submitForm()" [disabled]="shipmentArrivalForm.invalid">Search</button>
    <button class="btn btn-outline-primary" id="clearBtn" (click)="resetForm()">Clear</button>
  </div>

  @if (searchResult) {
  <div class="truck-result">
    <div class="truck-order">
      <div class="orderId">Order <span></span></div>
      <div class="customerName">{{ customerName }}</div>
    </div>

    @for (item of truckStats; track item; let i = $index) {
    <div class="horizontal-line"></div>

    <div class="truck-count">
      <div class="truck-value">{{ item.value }}</div>
      <div class="truck-label">{{ item.label }}</div>
    </div>
    }
  </div>
  } @for (shippingItem of shippingList; track shippingItem) { @if (shippingItem.deliveryDate) {
  <div class="section-title mb-2">{{ shippingItem.deliveryDate | date : 'MMM d' | uppercase }}</div>
  <div class="shipment-arrivals-result">
    <div class="shipment-header">
      <div>
        <span class="shipment-id">{{ shippingItem.shippingId }}</span>
        <span class="shipment-deliveryId">Del # {{ shippingItem.deliveryId }}</span>
      </div>
      <div
        class="badge"
        [ngClass]="{
          'shipment-today': shippingItem.label === 'Arriving today',
          'shipment-tomorrow': shippingItem.label === 'Arriving tomorrow',
          'shipment-later': shippingItem.label === 'Scheduled'
        }"
      >
        {{ shippingItem.label }}
      </div>
    </div>

    <div class="shipment-grid">
      <div>
        <div class="label">Ship-to</div>
        <div>{{ shippingItem.customerName }}</div>
        <div style="font-size: 12px">
          {{ shippingItem.deliveryAddress.city }}, {{ shippingItem.deliveryAddress.state }},
          {{ shippingItem.deliveryAddress.country }}
        </div>
      </div>
      <div>
        <div class="label">Order #</div>
        <div>{{ shippingItem.salesOrder }}</div>
      </div>
      <div>
        <div class="label">PO #</div>
        <div>{{ shippingItem.purchaseOrderNumber }}</div>
      </div>
      <div>
        <div class="label">Job name</div>
        <div>{{ shippingItem.jobName }}</div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="shipment-footer">
      <div class="carrier">
        {{
          shippingItem.carrierType === 'FREIGHT WATCHERS INC.' ? 'Carrier Assignment Pending' : shippingItem.carrierType
        }}
      </div>
      <div class="d-flex">
        <button class="btn btn-outline-primary mr-2" (click)="downloadFile(shippingItem)">Packing list</button>

        @if (shippingItem?.shippingNotificationLink) {
        <button class="btn btn-outline-primary mr-2" (click)="openTrackingLink(shippingItem?.shippingNotificationLink)">
          Track
        </button>
        }
      </div>
    </div>
  </div>
  } } @if (shippingList?.length == 0 && !(shipmentDataLoading$ | async)) {
  <div class="alert-info p-3 rounded mt-3">No deliveries expected in the next 7 days.</div>
  } @if (shipmentDataLoading$ | async) {
  <ng-container class="cx-spinner">
    <cx-spinner class="cx-dialog-popover-center-backdrop"></cx-spinner>
  </ng-container>
  }
</div>
